module.exports = "<simple-crud service=\"services.service\" translations=\"services.translations\" fields=\"services.fields\"></simple-crud>"


//////////////////
// WEBPACK FOOTER
// ./client/app/manager/services/services.pug
// module id = 221
// module chunks = 0